import { ENVIRONMENT } from '../constants';
import garmentsShopDev from './garmentsShop.development.json';
import garmentsShopStag from './garmentsShop.vto-stag2.json';
import garmentsShopProd from './garmentsShop.vto-prod.json';
import { Style } from './styleTypes';

export type VtoSizeRecommendation = {
  size: string;
};

/**
 * Get garment from ID.
 * Current done through JSON files rather than endpoints.
 * @param id Garment ID.
 */
export const fetchStyles = (): Promise<Style[]> => {
  let response: Style[];

  switch (ENVIRONMENT) {
    case 'vto-prod':
      response = garmentsShopProd as Style[];
      break;
    case 'vto-stag2':
      response = garmentsShopStag as Style[];
      break;
    default:
      response = garmentsShopDev as Style[];
      break;
  }

  return Promise.resolve(response);
};

/**
 * Get style from ID.
 * * Current done through JSON files rather than endpoints.
 * @param id Style ID.
 */

// Note: Return value is not a summary object when fetching from an actual endpoint
export const fetchStyle = async (id: string): Promise<Style> => {
  const styles = await fetchStyles();
  const style = styles.find((style: Style) => {
    return style.id === id;
  });
  return style ?? ({} as Style);
};
